<template>
  <v-main>
    <AppBar extension-height="49px">
      <div v-if="!this.isSamsungFire">
        <v-tabs v-model="tab" flat center-active slider-size="3" class="tabs" color="#000">
          <v-tab @click="scTabs('ALL')">전체</v-tab>
          <v-tab v-for="(item, index) in tabs" :key="index" :ripple="false" @click="scTabs(item.cd)">{{ item.cdNm }}
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
      </div>
    </AppBar>
    <v-container>
      <v-expansion-panels accordion flat>
        <v-expansion-panel v-for="(item,i) in faqList" :key="i">
          <v-expansion-panel-header>{{ item.title }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-html="item.content"></div>
            <div v-if="item.imgAtchFileName !== '' && item.imgAtchFileName !== null" class="mt-5">
              <v-img :src="$downUrl(item.imgAtchFileName)" contain/>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </v-main>
</template>
<script>
import store from '../../../store'
import {mixinAuth} from '@/mixins'

export default {
  data: () => ({
    tab: 0,
    tabs: [],
    faqList: [],
  }),
  created() {
    if (!this.isSamsungFire) {
      this.getCodeList('SY011')
    }
    this.readList('ALL')
  },
  mixins: [mixinAuth],
  methods: {
    initItems() {
      this.faqList = [];
      this.readList(this.typeItem);
    },
    scTabs(cd) {
      this.typeItem = cd;
      this.initItems();
    },
    async getCodeList(cdGrp) {
      await store.dispatch('getCodeList', this.$_payload({'cdGrp': cdGrp}))
          .then(res => {
            if (res.success) {
              this.tabs = res.data;
            } else {
              console.log(res.msg)
              this.tabs = [];
            }
          })
          .catch(error => {
            console.error(error)
            this.tabs = [];
          })
          .finally(() => {
          })
    },
    async readList(ctg) {
      if (this.isSamsungFire) {
        //TODO. 어드민 기능 추가 되면 수정
        this.faqList = [
          {
            "faqNo": 1,
            "title": "집중관리 및 일반관리가 뭔가요?",
            "content": "전체 12개월의 프로그램 중 원할 때 티켓을 사용하여 3개월의 집중관리를 받을 수 있습니다.</br>-일반관리 9개월 동안에는 매일 제공되는 마음날씨(나의 마음상태 체크리스트)와 마음노트(일기쓰기)를 이용할 수 있으며, 마음관리와 관련된 다양한 정보 제공, 소감문을 통한 커뮤니티 활동을 진행합니다.</br>-집중관리 동안에는 3개월간 매일 맞춤화된 데일리미션을 제공받으며, 마음여행 가이드와의 주 1회 찐한대화, 수행한 주요 미션에 대한 피드백이 일반관리와 함께 진행됩니다. ",
          },
          {
            "faqNo": 7,
            "title": "여행지원서는 뭔가요?",
            "ctg": "06",
            "content": "고객이 자신의 마음상태를 확인하고 그에 맞는 맞춤형 솔루션을 제공하기 위한 목적으로 개발된 심리검사입니다. 자기보고설문과 온라인신경심리게임, 투사검사 등을 통해 현 심리적 상태(우울, 불안, 스트레스, 감정상태)와 심층적 심리상태(자아강도, 대인관계, 인식/표현, 자기조절, 지지자원)를 평가하고 그 결과 리포트를 제공합니다.",
          },
          {
            "faqNo": 2,
            "title": "여행지원서는 꼭 작성해야 하는 건가요?",
            "ctg": "01",
            "content": "여행지원서는 고객에 맞춤화된 솔루션을 제공하기 위해 개발된 심리검사로 서비스를 위해서는 꼭 작성해야 합니다.",
          },
          {
            "faqNo": 10,
            "title": "여행지원서를 다시 작성하고 싶어요.",
            "ctg": "09",
            "content": "여행지원서는 일반관리 기간 동안에는 [여행가방>나의 마음나무 > 검사결과보기 > 여행지원서 새로 작성하기]를 통해 언제든 다시 마음상태를 확인할 수 있습니다. 집중관리 기간 중에는 작성이 불가능하며, 집중관리가 끝난 시점에 검사를 재진행할 수 있습니다.",
          },
          {
            "faqNo": 11,
            "title": "일반관리 기간 중 집중관리를 받고 싶으면 어떻게 해야 하나요?",
            "ctg": "10",
            "content": "메인화면의 메시지(보유 티켓으로 여행을 떠나보세요)를 클릭하거나, [여행가방>내 티켓]을 클릭하여 티켓을 선택하면 바로 집중관리가 가능합니다. 단, 집중관리 티켓은 조기소진 될 수 있습니다.",
          },
          {
            "faqNo": 5,
            "title": "추천 솔루션과 [오늘의 미션]에 대해 알려 주세요.",
            "ctg": "04",
            "content": "여행지원서의 결과에 기반하여 맞춤형 추천 솔루션이 3개월간의 마음여행 일정으로 제공됩니다. 매일 진행되는 미션들은 메인화면의 [오늘의 미션]에서 확인할 수 있습니다.",
          },
          {
            "faqNo": 3,
            "title": "심리 상담을 받을 수 있는 건가요?",
            "ctg": "02",
            "content": "전통적인 의미의 심리상담과는 다른 디지털기반의 상담이 제공됩니다. 고객이 스스로 마음관리를 할 수 있도록 주기적인 상담적 대화를 제공하고 촉진하는 찐한대화가 진행됩니다.",
          },
          {
            "faqNo": 4,
            "title": "찐한대화 시간을 변경하고 싶어요.",
            "ctg": "03",
            "content": "찐한대화 일정변경은 [찐한대화 > 우측 상단 ≡ 버튼 > 찐한대화 일정/변경] 통해 원하는 요일과 시간대로 변경할 수 있습니다. 단, 변경된 일정은 변경일 기준으로 다음주 일정부터 반영됩니다.",
          },
          {
            "faqNo": 8,
            "title": "찐한대화는 뭔가요?",
            "ctg": "07",
            "content": "찐한대화는 집중관리 기간에만 제공되는 서비스로, 가이드와 함께 채팅 방식으로 주 1회 정해진 요일의 4시간 동안 자유롭게 최대 30분간 대화합니다. 고객이 마음여행을 잘 진행할 수 있도록 상담적 대화와 전문적인 피드백, 맞춤형 정보를 제공합니다.",
          },
          {
            "faqNo": 9,
            "title": "가이드는 뭔가요?",
            "ctg": "08",
            "content": "마음여행 동안 곁에서 안내하는 가이드의 개념으로 5종의 가이드 캐릭터 중 하나를 선택할 수 있습니다. 심리 및 상담의 전문가들로 집중관리 기간 동안 마음여행 일정 전반을 관리하며 찐한대화, 미션에 대한 피드백을 제공합니다.",
          },
          {
            "faqNo": 6,
            "title": "뱃지는 무엇이고 언제 획득할 수 있나요?",
            "ctg": "05",
            "content": "뱃지는 고객이 마음건강관리를 위해 맞춤형 솔루션 및 서비스를 이용하는 과정에서 동기를 부여하고 마음여행을 진행을 촉진하기 위한 이벤트입니다. 뱃지는 미션을 잘 수행할 대, 정보성 콘텐츠의 ‘좋아요’를 누를 때, 소감글을 남길 때 등에 획득할 수 있습니다. [여행가방 > 내 뱃지]에서 획득한 뱃지 정보를 확인할 수 있습니다.",
          },
        ]
      } else {
        await store.dispatch('getFaqForCtg', this.$_payload({'ctg': ctg}))
            .then(res => {
              if (res.success) {
                this.faqList = res.data
              } else {
                console.log(res.msg)
                this.faqList = []
              }
            })
            .catch(error => {
              console.error(error)
              this.faqList = []
            })
            .finally(() => {
            })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .v-toolbar__extension {
  padding-left: 0;
  padding-right: 0;
}

::v-deep .tabs {
  //padding-left: $container-padding-x;
  //padding-right: $container-padding-x;
  .v-slide-group__prev {
    display: none !important;
  }

  .v-tab {
    padding: 0;
    min-width: 0;
    margin-left: $container-padding-x;
    font-size: 16px;

    &:last-child {
      margin-right: $container-padding-x;
    }

    &:before {
      background-color: transparent !important;
    }
  }

  .v-tabs-slider {
    border-radius: 3px;
  }
}

.no-data {
  height: calc((calc(var(--vh, 1vh) * 100) - 136px));
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #C4C4C4;
}

.v-expansion-panels::v-deep {
  .v-expansion-panel {
    border-bottom: 1px solid #E6E8EA;
  }

  .v-expansion-panel-header {
    padding-left: 0;
    padding-right: 0;
    font-size: 16px;
    line-height: 1.5;
    color: #000;
  }

  .v-expansion-panel-header__icon {
    .mdi-chevron-down::before {
      width: 24px;
      height: 24px;
      content: '';
      background: url('~@/assets/images/ic_arrow_right3.svg') right 7px center no-repeat;
      transform: rotate(90deg);
    }
  }
}
</style>
